module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAgCAYAAABgrToAAAAAAXNSR0IArs4c6QAAAVxJREFUWEft2MFOgzAYB/B/I8iyAyxehESOk8uIZzey+Rq+iA/hg+hjuJG9gNd5NXrCuJpsQzA1XcKyGDXFYvod4Eig/Pr/WihlALBaiZPiY3MN4EIIBPKcqYMxPAOY2gedq26XPbItrtzcC+DIFOq75zLgxbY6Z2z5tr4RApeUcJWFMdxK4JPpsv4Ujiw3e+VrQTG9XYotULM8bYk1A8SfEszzHIvFA8IwRK/n6Rp+vb82UOJm6Rycc0RRH/FgQAe4j/NcF+NJAufQoQE0gZM9VyqxKZwS0CROCXg3TZFlGWzLQlGWjY433z9GMhrqzeIKaNk2yqJoFBgEPkbDcz1g/p4jnc2x5Byu62IyTuA4/ztz98Vqk8QgUgkoe2QqSWWgKWQt4FdkdNpHHBP61FWDV5Z7t1jwiC0WGn3PKDRWu8QKbTZ6SQvUjZN+guR/3MlvfZDfPJKDmPL22yffaBkCijqdrQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/back.png
// module id = P9/e
// module chunks = 2